import { useNavigate } from 'react-router-dom'

interface Props {
  orderNo?: string
}

export default function SubmitSuccess({ orderNo }: Props) {
  const navigate = useNavigate()

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 24px',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 360, width: '100%' }}>
        {/* 绿色对勾 */}
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: '#52c41a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            boxShadow: '0 4px 12px rgba(82,196,26,0.3)',
          }}
        >
          <svg width="36" height="36" fill="none" stroke="#fff" viewBox="0 0 24 24" strokeWidth={3}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* 标题 */}
        <h2
          style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 24,
            fontWeight: 600,
            color: '#313131',
            letterSpacing: '0.12em',
            marginBottom: 8,
          }}
        >
          提交成功
        </h2>

        <p style={{ fontSize: 14, color: '#888', marginBottom: 24, lineHeight: 1.8 }}>
          亲，收到材料后约7个工作日完成。
          <br />
          定制系统里面可以实时查看定制的记录和进度，
          <br />
          并且也会有对应的短信进行通知，
          <br />
          可以关注一下。
        </p>

        {/* 二维码卡片 */}
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: 12,
            padding: 20,
            marginBottom: 16,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }}
        >
          <img
            src={`${import.meta.env.BASE_URL}images/wechat-qrcode.jpg`}
            alt="微信客服二维码"
            style={{
              width: 200,
              height: 200,
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </div>

        {/* 底部提示 */}
        <p style={{ fontSize: 13, color: '#999', lineHeight: 1.6, marginBottom: 32 }}>
          扫码添加客服微信
          <br />
          如有问题请联系客服处理
        </p>

        {orderNo && (
          <p style={{ fontSize: 12, color: '#bbb', marginBottom: 16 }}>
            订单号：{orderNo}
          </p>
        )}

        {/* 查看订单进度 */}
        <button
          onClick={() => {
            if (orderNo) {
              // 整页跳转强制刷新，避免同路由不重挂载导致仍停留在成功页
              window.location.href = `${import.meta.env.BASE_URL}detail/${orderNo}`
            } else {
              navigate('/')
            }
          }}
          style={{
            width: '100%',
            height: 48,
            backgroundColor: '#313131',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 500,
            cursor: 'pointer',
            letterSpacing: '0.1em',
          }}
        >
          查看订单进度
        </button>
      </div>
    </div>
  )
}
